import { deployEnvironmentLabel } from '@/lib/deployEnvironment'

/**
 * Names the internal environment beside the logo, and renders nothing at all on
 * production or on any client deployment.
 *
 * It is separate from VersionChip on purpose. The product version is one shared
 * counter minted on staging as a release tag, and dev shows the newest one, so
 * dev and staging can show the same number (dev only adds "-dev.N" while it holds unreleased
 * changes) and the number can never answer "which environment is this". That
 * question gets its own label rather than a suffix on the version.
 *
 * Unlike VersionChip this imports nothing from `@/help/registry`, so it carries
 * no bundle weight and no import restriction. `src/mobile/**` may use it.
 */
export function EnvironmentBadge() {
  // Read per render rather than at module scope so the value cannot be baked
  // into a chunk during a prerender or a test import (same reason as TopBar).
  const label = deployEnvironmentLabel(window.location.hostname)
  if (!label) return null

  return (
    <span
      title={`${label} environment`}
      className='shrink-0 rounded border border-amber-300 bg-amber-50 px-1.5 py-0.5 font-mono text-[10px] font-medium uppercase leading-none tracking-wide text-amber-700'
    >
      {label}
    </span>
  )
}
